module.exports = __webpack_public_path__ + "img/top.1ff6b789.png";